import { render, staticRenderFns } from "./Albums.vue?vue&type=template&id=fbf5f638&scoped=true&lang=html&"
import script from "./Albums.vue?vue&type=script&lang=js&"
export * from "./Albums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5f638",
  null
  
)

export default component.exports